import mutations from './mutations';
import { DataService } from '@/config/dataService/dataService';
import { notification } from 'ant-design-vue';

const state = () => ({
    data: [],
    loading: false,
    error: null,
    currentItem: {},
    totalRecords: 0,
    ticketsCount:[],
});

const actions = {
    async ticketRead({ commit }, id) {
        try {
            commit('ticketReadBegin');
            const response = await DataService.get(`/tickets/${id}`);
            commit('ticketReadSuccess', response.data.data);
        } catch (err) {
            commit('ticketReadErr', err);
        }
    },

    async ticketReadAll({ commit }, data) {
        try {
            commit('ticketReadAllBegin');
            const response = await DataService.get(`/tickets?${new URLSearchParams(data).toString()}`);
            commit('ticketReadAllSuccess', response.data.data);
        } catch (err) {
            commit('ticketReadAllErr', err);
        }
    },

    async ticketAdd({ commit }, data) {
        try {
            commit('ticketAddBegin');
            const response = await DataService.post('/tickets', data);
            commit('ticketAddSuccess', response.data.data);

            notification.success({
                message: response.data.message,
            });
        } catch (err) {
            commit('ticketAddErr', err);
        }
    },

    async ticketMessageAdd({ commit }, data) {
            commit('ticketMessageAddBegin');
            await DataService.post(`/ticket/messages`, data).then((response) => {
                commit('ticketMessageAddSuccess', response.data.data);
                notification.success({
                    message: response.data.message,
                    placement: 'topRight'
                });
            }).catch((err) => {
                commit('ticketMessageAddErr', err);
            });

    },

    async ticketUpdate({ commit }, data) {
            commit('ticketUpdateBegin');
            await DataService.put(`/tickets/${data.id}`, data).then((response) => {
                commit('ticketUpdateSuccess', response.data.data);
                notification.success({
                    message: response.data.message,
                    placement: 'topRight'
                });
            }).catch((err) => {
                commit('ticketUpdateErr', err);
            });
    },

    async ticketCount({ commit }) {
        await DataService.get(`/ticket/count`).then((response) => {
            commit('ticketCountSuccess', response.data.data);
        }).catch((err) => {
            console.log(err);
        });
    },
};

export default {
    namespaced: false,
    state,
    actions,
    mutations,
  };